import React from "react";
import {
  Link
} from "react-router-dom";
import config from './../../config.js';
import Loading from './../../../components/loading.js';
import Notification from 'rc-notification';
import Modal from './../../../components/modal.js';
import Dropdown from './../../../components/dropdown.js';
import Editsubject from './edit_subject.js';
import Tagsubject from './tag_subject.js';

let notification = null;
Notification.newInstance({
  style: {
    top: '45px',
    right: 0
  }
}, (n) => notification = n);

export default class Subjectfiles extends React.Component {

  constructor(props) {
    super(props);
    let user = {};
    let uistyle = {};
    if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
      user = JSON.parse(localStorage.user);
      if (typeof user.company.type !== 'undefined' && user.company.type !== '') {
        uistyle = JSON.parse(user.company.type);
      }
    }

    const {
      projectid,
      subjectid,
      data_type
    } = props.match.params;

    const pagetitle = '数据管理 ';
    let page_subtitle = data_type == 0 || data_type == '' ? '' : data_type.toUpperCase();
    page_subtitle += ' 受试者数据详情';

    const dicomviewurl = config.dicomviewer; //(user.company_id === '3') ? config.dicomviewer.ad : config.dicomviewer.pd;
    const petviewurl = config.petviewer;

    const paramsString = props.location.search.substring(1);
    const searchParams = new URLSearchParams(paramsString);
    const backurl = searchParams.get('to');
    const subject_uid = searchParams.get('uid');
    //console.log(backurl)
    this.state = {
      loading: false,
      user: user,
      projectid: projectid,
      page_title: pagetitle,
      page_subtitle: page_subtitle,
      subjectid: subjectid,
      data_type: data_type, //MR or PT [modality]
      project: '',
      creator: '',
      subject: '',
      ismodal: false,
      current_fileid: '',
      current_projectid: '',
      files: [],
      ismodal_download: false,
      downloadurl: '',
      download_message: '',
      dicomviewurl: dicomviewurl,
      petviewurl: petviewurl,
      percent: 0,
      showProgess: false,
      createModal: false,
      taskType: '',
      hasSomeFile: {
        PT: false,
        MR: false,
        CT: false
      },
      current_file: null,

      pt_status: false,
      pt_ok: false,

      ptct_status: false,
      ptct_ok: false,

      mr_status: false,
      mr_ok: false,

      ptmr_status: false,
      ptmr_ok: false,
      backurl: backurl || '',
      uistyle: uistyle,
      tagids: [],
      tagname: '',
      subject_id: 0,
      subject_name: '',
      subject_age: 50,
      subject_explain: '',
      subject_gender: '',
      subject_uid: subject_uid || '',
      subject_userid: '',
      subject_tags: [],
      edit_type: '',
      modalOpen: false,
      current_task: {},
      t1_modal_title: '',
      t1_result_link: '',
      isOpenModal: false //点通过时自动创建pet任务 

    }

    document.title = pagetitle + page_subtitle;
    this.goback = this.goback.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.submitModal = this.submitModal.bind(this);
    this.modal = this.modal.bind(this);
    this.download = this.download.bind(this);
    this.closeCreateModal = this.closeCreateModal.bind(this)
    this.createModalSubmit = this.createModalSubmit.bind(this)
    this.createTask = this.createTask.bind(this)
    this.createPetMrOrPetCtOrPet = this.createPetMrOrPetCtOrPet.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.modalSubmit = this.modalSubmit.bind(this);
  }

  componentDidMount() {
    let onInitialSubject = new Promise(this.onInitialSubject.bind(this));
    if (this.state.projectid > 0) this.getProject();
    onInitialSubject.then((res) => {
      // this.createPetMrOrPetCtOrPet();
    });


  }

  componentWillReceiveProps(nextProps) {
    const data_type = nextProps.match.params.data_type;

    const paramsString = nextProps.location.search.substring(1);
    const searchParams = new URLSearchParams(paramsString)
    const backurl = searchParams.get('to');

    this.setState({
      data_type: data_type,
      backurl: backurl || ''
    })
  }

  getProject() {
    const me = this;
    let {
      projectid,
      user
    } = me.state;
    const postdata = {
      userid: user.id,
      companyid: user.company_id,
      projectid: projectid,
      Authorization: localStorage.token,
      request: 'project'
    };
    fetch(config.host + '/project/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) {
          const data = json.data;
          me.setState({
            project: data.project,
            creator: data.creator
          });
        } else {
          //me.notify(json.message);
          console.log(json.message);
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  goback() {
    const me = this;
    //this.props.history.goBack(1);
    const {
      backurl
    } = this.state;
    /*
    const paramsString = me.props.location.search.substring(1);
    const searchParams = new URLSearchParams(paramsString)
    const backurl = searchParams.get('to');
*/
    me.props.history.push(backurl);
  }

  notify(message) {
    notification.notice({
      content: `${message}`,
      duration: 4,
      style: {
        'bottom': 0,
        'right': 0
      }
    });
  }

  modal() {
    this.setState({
      ismodal: true
    });
  }

  closeModal() {
    this.setState({
      loading: false,
      ismodal: false,
      ismodal_download: false,
      modalOpen: false,
      tagids: [],
      tagname: ''
    });
  }

  submitModal() {
    const fileid = this.state.current_fileid;
    const project_id = this.state.current_projectid;
    this.submitBrainlabel(fileid, project_id, 'redo_brainlabel')
  }

  onInitialSubject(resolve, reject) {
    const me = this;
    let {
      user,
      projectid,
      subjectid,
      data_type,
      subject_uid
    } = me.state;
    let postdata = {
      userid: user.id,
      projectid: projectid,
      subjectid: subjectid,
      data_type: data_type,
      Authorization: localStorage.token,
      post_type: 'detail'
    };

    if (subjectid == 0 && subject_uid != '') {
      postdata = {
        userid: user.id,
        projectid: projectid,
        uid: subject_uid,
        data_type: data_type,
        Authorization: localStorage.token,
        post_type: 'detail_uid'
      };
    }

    fetch(config.host + '/project_subject/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        if (json.status === 1) {
          const data = json.data;
          data.head.forEach((h) => {
            h.checked = false;
            h.checkedfiles = 0;
            if (data_type == 0) {
              h.ifshow = true;
            } else {
              h.ifshow = h.modality == data_type ? true : false;
            }
            if (h.files.length) {
              h.files.forEach((f) => {
                f.checked = false;
              });
            }
          });
          me.setState({
            projectid: data.project_id,
            subject: data
          });

          if (data.project_id > 0) {
            me.getProject();
          }
        }
        resolve(json);
      })
      .catch(function(error) {
        console.log(error);
        reject(false);
      });
  }

  approx(bytevalue) { //计算文件单位和大小
    let filebtout = '';
    for (let units = ["KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], n = 0, Approx = bytevalue / 1024; Approx > 1; Approx /= 1024, n++) {
      filebtout = Approx.toFixed(3) + " " + units[n];
    }
    return filebtout;
  }

  submitBrainlabel(fileid, project_id, request) {
    const me = this;
    if (!config.isbrainlabel) {
      me.notify('全脑分割系统正在维护中，请稍候再来');
      return;
    }
    let {
      user
    } = me.state;
    me.setState({
      loading: true
    });
    const postdata = {
      userid: user.id,
      level: user.level,
      fileid: fileid,
      projectid: project_id,
      companyid: user.company_id,
      Authorization: localStorage.token,
      request: request
    };
    fetch(config.host + '/brainlabel/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        me.setState({
          loading: false
        });
        if (json.status === 1) {
          //redirect to brainlabel task list page
          //me.props.history.push('/console/myprojects/project/service_list/' + project_id + '/brainlabel');
          me.props.history.push('/console/list_service/' + project_id + '/brainlabel')
          return;
        }
        if (json.status === 2) {

          let t1_modal_title = '该文档已经处理过全脑分割';
          let t1_result_link = '/console/myprojects/project/service_list/' + project_id + '/brainlabel';

          switch (json.task.status) {
            case '0':
              t1_modal_title = '该文档正在等待进行全脑分割';
              break;
            case '1':
              t1_modal_title = '该文档正在进行全脑分割，进度:' + json.task.complete_per + '%';
              break;
            case '2':
              t1_result_link = config.t1viewer + '?uid=' + user.id + '&cid=' + user.company_id + '&tid=' + json.task.task_id + '&requrl=' + config.host + '/t1view/index/';
              t1_modal_title = '该文档已完成全脑分割';
              break;
            case '3':
              t1_modal_title = '该文档全脑分割处理失败';
              break;
          }


          me.setState({
            ismodal: true,
            current_projectid: project_id,
            current_fileid: fileid,
            current_task: json.task,
            t1_modal_title: t1_modal_title,
            t1_result_link: t1_result_link
          });
        } else {
          me.notify(json.message);
        }


      })
      .catch(function(error) {
        console.log(error);
      });
  }

  checkhead(headid) {
    let {
      subject,
      files
    } = this.state;

    subject.head.forEach((h) => {
      if (h.headid === headid) {
        h.checked = !h.checked;
        h.checkedfiles = h.checked ? h.total_files : 0;
        if (h.files.length) {
          h.files.forEach((f) => {
            f.checked = h.checked;
            if (f.checked) {
              files.push(f.id);
            } else {
              files = files.filter((ft) => {
                return ft !== f.id
              });
            }

          });
        }
        return;
      }
    });
    //console.log(files);
    this.setState({
      files: files,
      subject: subject
    });
  }

  checkfile(headid, fileid) {
    let {
      subject,
      files
    } = this.state;

    subject.head.forEach((h) => {
      if (h.headid === headid) {
        h.files.forEach((f) => {
          if (f.id === fileid) {
            f.checked = !f.checked;
            h.checkedfiles = f.checked ? h.checkedfiles + 1 : h.checkedfiles - 1;
            if (f.checked) {
              files.push(f.id);
            } else {
              files = files.filter((ft) => {
                return ft !== f.id
              });
            }
            return;
          }

        });
        h.checked = h.checkedfiles > 0;
        return;

      }
    });
    //console.log(files);

    this.setState({
      files: files,
      subject: subject
    });
  }

  download() {
    //console.log('开始zip打包');
    const me = this;
    let {
      user,
      projectid,
      data_type,
      subject,
      files
    } = this.state;

    if (!files.length) {
      me.notify('没有选择文件');
      return;
    }

    me.setState({
      loading: true,
      download_message: '正在打包...',
      ismodal_download: true
    });

    const postdata = {
      userid: user.id,
      data_type: data_type,
      subjectid: subject.id,
      files: files,
      projectid: projectid,
      companyid: user.company_id,
      Authorization: localStorage.token,
      request: 'download_datatype'
    };

    fetch(config.host + '/download/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        //console.log(json);

        me.setState({
          loading: false
        });
        if (json.status === 1 && json.downloadurl) {
          me.setState({
            loading: false,
            download_message: '点击下载',
            downloadurl: json.downloadurl
          });
        } else {
          me.setState({
            ismodal_download: false
          });
        }
        me.notify(json.message);
      })
      .catch(function(error) {
        console.log(error);
      });
  }


  download_dicom(fileid) {
    //console.log('dicom开始zip打包');
    const me = this;
    let {
      user,
      projectid,
      data_type
    } = this.state;


    me.setState({
      loading: true,
      download_message: '正在打包...',
      ismodal_download: true
    });

    const postdata = {
      userid: user.id,
      data_type: data_type,
      fileid: fileid,
      projectid: projectid,
      companyid: user.company_id,
      Authorization: localStorage.token,
      request: 'download_file_dicom'
    };

    fetch(config.host + '/download/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        //console.log(json);

        me.setState({
          loading: false
        });
        if (json.status === 1 && json.downloadurl) {
          me.setState({
            loading: false,
            download_message: '点击下载',
            downloadurl: json.downloadurl
          });
        } else {
          me.setState({
            ismodal_download: false
          });
        }
        me.notify(json.message);
      })
      .catch(function(error) {
        console.log(error);
      });
  }



  download_nii(fileid) {
    //console.log('nii开始zip打包');
    const me = this;
    let {
      user,
      projectid,
      data_type
    } = this.state;


    me.setState({
      loading: true,
      download_message: '正在打包...',
      ismodal_download: true
    });

    const postdata = {
      userid: user.id,
      data_type: data_type,
      fileid: fileid,
      projectid: projectid,
      companyid: user.company_id,
      Authorization: localStorage.token,
      request: 'download_file_nii'
    };

    fetch(config.host + '/download/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        //console.log(json);

        me.setState({
          loading: false
        });
        if (json.status === 1 && json.downloadurl) {
          me.setState({
            loading: false,
            download_message: '点击下载',
            downloadurl: json.downloadurl
          });
        } else {
          me.setState({
            ismodal_download: false
          });
        }
        me.notify(json.message);
      })
      .catch(function(error) {
        console.log(error);
      });
  }


  createTask(file, isOpenModal = false) { //isOpenModal 模态弹窗隐藏状态 
    this.state.current_file = file;
    this.setState(this.state);
    let {
      user,
      projectid,
      data_type,
      subject,
      files,
      current_file,
      taskProcessProgress
    } = this.state;


    let study_uid = current_file['study_instance_uid'];
    let fileid = current_file['id'];
    let me = this,
      postdata = {
        project_id: projectid,
        subject_id: subject.id,
        file_id: file.id,
        study_instance_uid: study_uid,
        Authorization: localStorage.token
      };

    fetch(config.host + '/pet_service/dicomTypes', {
      method: 'post',
      body: JSON.stringify(postdata)
    }).then(res => res.json()).then(json => {
      if (json.status == 1 && json.data) {
        json.data.forEach((ele, index) => {
          if (ele.modality) {
            this.state.hasSomeFile[ele.modality] = true;
            this.setState(this.state);
          }
        });
        // for ( let key  in this.state.taskProcessProgress) {
        //     this.state.taskProcessProgress[key] = {};
        // }
        this.state.pt_status = false;
        this.state.ptct_status = false;
        this.state.ptmr_status = false;
        this.state.mr_status = false;

        json.tasks && json.tasks.forEach((ele, i) => {
          let type = ele.type_name.toLowerCase();
          let status = ele.status;
          let id = ele.id;
          if (type == 'pt') {
            this.state.pt_status = status;
            this.state.pt_ok = ele;
          } else if (type == 'ptct') {
            this.state.ptct_status = status;
            this.state.ptct_ok = ele;
          } else if (type == 'ptmr') {
            this.state.ptmr_status = status;
            this.state.ptmr_ok = ele;
          } else if (type == 'mr') {
            this.state.mr_status = status;
            this.state.mr_ok = ele;
          }
        });
        this.setState(this.state);
        //console.log(this.state.taskProcessProgress);
      } else if (json.status == 0) {
        me.notify(json.message);
      }
    }).catch(function(error) {
      console.log(error);
      me.notify(error);
    });

    this.setState({
      createModal: isOpenModal
    });
  }


  createPetMrOrPetCtOrPet(isAutoPetTask = false) {
    let me = this,
      {
        user,
        projectid,
        data_type,
        subject,
        current_file
      } = this.state,
      timer = null;
    var study_uid = current_file['study_instance_uid'];
    var fileid = current_file['id'];
    let taskType = this.state.taskType;

    me.setState({
      loading: true
    });
    var postdata = {
      user_id: user.id,
      type_name: taskType,
      subject_id: current_file.subject_id,
      project_id: projectid,
      company_id: user.company_id,
      Authorization: localStorage.token,
      study_instance_uid: study_uid,
      file_id: fileid,
      subject_age: subject.subject_age,
      subject_uid: subject.subject_uid,
      request: 'create_pet'
    };

    let petFunc = () => {
      fetch(config.host + '/pet_service/index', {
          method: 'post',
          body: JSON.stringify(postdata)
        }).then(res => res.json())
        .then(json => {
          if (json.status == 1 && json.data) {
            !isAutoPetTask && me.notify(json.message);
            setTimeout(() => {
              !isAutoPetTask && me.props.history.push('/console/myprojects/project/service_list/' + projectid + '/pet');
            }, 1000);
          } else {
            !isAutoPetTask && me.notify(json.message);
          }
          me.setState({
            loading: false
          });
        }).catch(function(error) {
          console.log(error);
          me.notify(error);
          me.setState({
            loading: false
          })
        });
    }
    petFunc();
  }

  closeCreateModal() {
    this.setState({
      createModal: false
    });
  }
  autoPetTask(file) {
    this.state.current_file = file;
    this.state.taskType = 'PT'
    this.setState(this.state);
    this.createPetMrOrPetCtOrPet(true);
  }
  createModalSubmit() {
    if (!this.state.taskType) {
      this.notify('未选择任务.');
      return;
    }
    this.createPetMrOrPetCtOrPet();
    this.setState({
      createModal: false
    });
  }
  handleChange(e) {
    this.setState({
      taskType: e.target.value
    });
  }

  viewImg(task, type) {
    let {
      petviewurl
    } = this.state;
    let url = `${petviewurl}?type=${task.type_name}&tid=${task.task_id}&cid=${task.company_id}&keyid=${task.id}&requrl=/petview/index/&host=${config.host}`;
    window.open(url, '_blank');
  }

  qcfile(id, state, file) {
    const me = this;
    let cur_uid = this.state.subject.subject_uid;
    if (file['modality'] == 'PT' && cur_uid && file['company_id'] == 5) {
      file.qc_state = state
      file.qc_state == 1 && this.autoPetTask(file);
      this.setState(this.state)
        // return
    }

    let {
      user,
      projectid,
      subject
    } = me.state;
    const postdata = {
      userid: user.id,
      projectid: projectid,
      companyid: user.company_id,
      fileid: id,
      qc_state: state,
      Authorization: localStorage.token,
      post_type: 'qc_file'
    };
    fetch(config.host + '/project_subject/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      }).then(res => res.json())
      .then(json => {
        if (json.status == 1) {
          subject.head.map((t, i) => {
            if (t.files == false || !t.files.length) return;

            t.files.map((file, n) => {
              if (file.id == id) file.qc_state = state;
              return file;
            });
            return t;
          });
          me.setState({
            subject: subject
          })
        }
      });
  }

  qcmodality(modality, state) {
    const me = this;
    const {
      user,
      subject,
      projectid,
      subjectid
    } = me.state;
    const postdata = {
      userid: user.id,
      subjectid: subjectid,
      modality: modality,
      qc_state: state,
      projectid: projectid,
      Authorization: localStorage.token,
      post_type: 'qc_modality'
    };
    fetch(config.host + '/project_subject/index', {
        method: 'post',
        body: JSON.stringify(postdata)
      }).then(res => res.json())
      .then(json => {
        if (json.status == 1) {
          subject.subject_modality.map((m, i) => {
            if (m.modality == modality && m.subject_id == subjectid) m.qc_state = state;
            return m;
          });
          me.setState({
            subject: subject
          })
        }
      });
  }


  modalitylist(m) {
    const me = this;
    const {
      subject
    } = me.state;

    subject.head.forEach((h) => {
      h.checked = false;
      h.checkedfiles = 0;
      if (m == 0) {
        h.ifshow = true;
      } else {
        h.ifshow = h.modality == m ? true : false;
      }

      if (h.files.length) {
        h.files.forEach((f) => {
          f.checked = false;
        });
      }
    });

    me.setState({
      data_type: m,
      subject: subject
    });
  }


  /**
   * subject edit and tags setting
   * @param  {[type]} subject   [description]
   * @param  {[type]} edit_type [description]
   * @return {[type]}           [description]
   */
  modalSubject(subject, edit_type) {
    if (edit_type === 'editsubject') {
      this.setState({
        modalOpen: true,
        edit_type: edit_type,
        modaltitle: '修改受试者信息',
        subject_id: subject.id,
        subject_name: subject.subject_name,
        subject_age: subject.subject_age,
        subject_gender: subject.subject_gender,
        subject_explain: subject.subject_explain || '',
        subject_uid: subject.subject_uid
      });
    }

    if (edit_type === 'tagsubject') {
      let subject_tagids = [];
      if (subject.tags.length) {
        subject.tags.map((t, i) => {
          subject_tagids.push(t.id);
        })
      }
      this.setState({
        modalOpen: true,
        edit_type: edit_type,
        modaltitle: '设置标签',
        subject_id: subject.id,
        subject_userid: subject.user_id,
        subject_tags: subject.tags,
        tagids: subject_tagids
      })
    }
  }


  handleInputChange(event) {
    const me = this;
    const target = event.target;
    const name = target.name;
    const value = target.value;
    const type = target.type;

    let tagids = me.state.tagids;
    //console.log(value)

    if (type == "checkbox" && name == "tagid") {

      if (tagids.indexOf(value) >= 0) {
        tagids = tagids.filter((ft) => {
          return ft !== value
        });
      } else {
        tagids.push(value);
      }

      me.setState({
        tagids: tagids
      })
    } else {

      me.setState({
        [name]: value
      })
    }
  }



  trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
  }


  modalSubmit() {
    const me = this;
    const {
      edit_type,
      subject_name,
      subject_age,
      tagids,
      tagname
    } = me.state;

    if (edit_type === 'editsubject') {
      if (me.trim(subject_name) === '') {
        me.notify('受试者名称不能为空');
        return;
      }
      if (subject_age.length > 4) {
        me.notify('受试者年龄错误');
        return;
      }
    }
    /*
        if (edit_type === 'tagsubject') {
          if (!tagids.length && me.trim(tagname) === '') {
            me.closeModal();
            return;
          }
        }
    */
    me.postModal();
  }


  postModal() {
    const me = this;
    const {
      user,
      projectid,
      edit_type,
      subject_id,
      subject_name,
      subject_age,
      subject_gender,
      subject_explain,
      subject_uid,
      subject_userid,
      tagids,
      tagname
    } = me.state;
    let postdata = '';
    let url = '';
    if (edit_type === 'editsubject') {
      url = config.host + '/project_subject/index';
      postdata = {
        userid: user.id,
        projectid: projectid,
        subject_id: subject_id,
        subject_name: subject_name,
        subject_gender: subject_gender,
        subject_age: subject_age,
        subject_explain: subject_explain,
        subject_uid: subject_uid,
        Authorization: localStorage.token,
        post_type: 'edit'
      };
    }

    if (edit_type === 'tagsubject') {
      url = config.host + '/tags/index';
      postdata = {
        userid: user.id,
        subject_id: subject_id,
        subject_userid: subject_userid,
        tagids: tagids,
        tagname: tagname,
        Authorization: localStorage.token,
        request: 'tagsubject'
      };
    }
    fetch(url, {
        method: 'post',
        body: JSON.stringify(postdata)
      })
      .then(res => res.json())
      .then(json => {
        me.notify(json.message);
        if (json.status === 1) {

          me.closeModal();
          if (edit_type === 'editsubject') {
            me.refreshSubject();
          }
          if (edit_type === 'tagsubject') {
            me.reloadSubjectTags(json.data);
          }

        } else {
          me.setState({
            loading: false
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }


  refreshSubject() {
    const me = this;
    const {
      subject_name,
      subject_age,
      subject_gender,
      subject_explain,
      subject_uid
    } = me.state;

    let subject = Object.assign(me.state.subject, {
      subject_name: subject_name,
      subject_age: subject_age,
      subject_gender: subject_gender,
      subject_explain: subject_explain,
      subject_uid: subject_uid
    });

    me.setState({
      subject: subject
    })
  }


  reloadSubjectTags(tags) {
    const me = this;
    let {
      subject
    } = me.state;
    subject.tags = tags;
    me.setState({
      subject: subject
    });
  }


  render() {
    const {
      user,
      projectid,
      subjectid,
      data_type,
      subject,
      downloadurl,
      download_message,
      dicomviewurl,
      uistyle,
      current_task,
      t1_modal_title,
      t1_result_link,
      project,
      creator
    } = this.state;

    var getStatusText = (status) => {
      switch (status) {
        case '0':
          return '待处理';
          break;
        case '1':
          return '正在处理';
          break;
        case '2':
          return '处理成功';
          break;
        case '3':
          return '处理失败';
          break;
      }
      return '';
    };


    return (
      <div className="row">
        <Loading display={this.state.loading} />
        <div className="col-9">
          <nav className="clearfix">
            <ol className="breadcrumb  animated fadeInLeft float-left">
              <li className="breadcrumb-item "><a className="text-dark " onClick={this.goback}><strong><i className="fa fa-chevron-left"></i> 返回</strong></a>
              </li>
              
              <li className="breadcrumb-item ">{this.state.page_subtitle}</li>
              
              { projectid > 0 &&
              <li className="breadcrumb-item ">
                创建者: {this.state.creator.realname || this.state.creator.username || this.state.creator.email || this.state.creator.title || this.state.creator.address || this.state.creator.office}
              </li>}
              { projectid > 0 && 
              <li className="breadcrumb-item ">
                <Link to={`/console/myprojects/project/${projectid}/0`} ><i className="fa fa-link"></i> 所在项目: {this.state.project.name}  </Link>
              </li>
              }

            </ol>
            <div className="btn-group  btn-group-sm float-right mr-2 animated fadeInRight">
              {
                typeof(subject.modality) !== 'undefined' && subject.modality.length > 1 && subject.modality.map((m, i) => { 
                  return <button className={`btn btn-sm px-3 ${data_type == m ? "btn-primary" : "btn-outline-secondary"}`} key={i} onClick={()=>this.modalitylist(m)}>{m=='archive' ? '其它' : m}</button> }) }
              {
                typeof(subject.modality) !== 'undefined' && subject.modality.length > 1 && 
                <button className={`btn btn-sm px-3 ${data_type == 0 ? "btn-primary" : "btn-outline-secondary"}`} onClick={()=>this.modalitylist(0)}>全部</button>
              }
            </div>
          </nav>

          <div className="bg-white pb-3 mb-3">
            {
              subject!=='' && subject.head.length>0 && 
              <div>
              {
              subject.head.map((t,i)=>{
                return(
                  <div key={i} className="mb-3" subjectid={t.subject_id} style={{"display":t.ifshow ? "block" : "none"}}>
                    <div className="px-3 pt-3" key={t.id}>
                      <div className="text-muted mb-1">
                        <div className="custom-control custom-checkbox d-inline-block">
                          <input type="checkbox" className="custom-control-input" id={'head_'+t.headid} name={'head_'+t.headid} checked={t.checked} onChange={()=>this.checkhead(t.headid)} value={t.headid} />
                          <label className="custom-control-label" htmlFor={'head_'+t.headid} title={t.study_instance_uid}>
                           检查序列 共<strong>{t.total_files}</strong>条 
                           {t.study_date && <span className="mx-1">检查日期：{t.study_date}</span>}
                           {t.manufacturer && <span className="mx-1">检查设备：{t.manufacturer}</span>}
                           {t.institution_name && <span className="mx-1">检查机构：{t.institution_name}</span>}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="px-3">
                    <table className="table table-hover">
                    <thead className="">
                      <tr>
                        <th width="25%">序列名称</th>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        {uistyle.is_qcstate && <th title="QC">质量检测</th>}
                        <th width="30%"></th>
                        <th className="text-right"></th>
                      </tr>
                    </thead>
                    <tbody>
                    {
                      t.files!==false && t.files.length && t.files.map((file,n)=>{
												//const birth = new Date(file.birthday);
												//const birthmonth = parseInt(birth.getMonth(),10)+1;
												//const birth_day = birth.getFullYear() + '-' + birthmonth + '-' + birth.getDate();
												//const birthday = birth.toLocaleDateString();
                        return (
                          <tr data-filepath={file.file_path + file.archive_name } key={n}>
														<td title={`扫描时间 SeriesDate：${file.series_date} (${file.orientation})`}>
                              <span className="custom-control custom-checkbox d-inline-block">
                                <input type="checkbox" className="custom-control-input" id={'file_'+file.id} groupid={file.attribute_id} subjectid={file.subject_id} checked={file.checked} name={'file_'+file.id} onChange={()=>this.checkfile(t.headid,file.id)} value={file.id} />
                                <label className="custom-control-label" htmlFor={'file_'+file.id}>
                                  <i className="d-line-block text-nowrap ">编号:{file.input_patientid || file.id}<br /> {file.series_name}</i>
                              
                                </label>
                              </span>
														</td>

                            <td className="text-center">
                            <i className="badge badge-pill badge-info mx-3 small">{file.modality}</i>
                            </td>
                            <td className="text-center">
                            <i className="badge badge-success mx-3 small">{file.series}</i>
                            </td>
                            {uistyle.is_qcstate && 
                            <td>
                              <Dropdown direction="dropright">
                                <div> 
                                {!file.qc_state || file.qc_state==0 ? <span>未检测</span> : null} 
                                {file.qc_state==1 ? <span>通过</span> : null} 
                                {file.qc_state==2 ? <span>不通过</span> : null} 
                                <i className="fa fa-bars ml-1"></i> <i className="fa fa-angle-down"></i></div>
                                <div>
                                    <div className="dropdown-header">质量检测</div>
                                    <div className="dropdown-item cursor" onClick={() => { this.qcfile(file.id,1,file) }}><i className="fa fa-calendar-check"></i> 通过 </div>
                                    <div className="dropdown-item cursor" onClick={() => { this.qcfile(file.id,2,file) }}><i className="fa fa-calendar-times"></i> 不通过 </div>
                                    <div className="dropdown-divider"></div>
                                    <div className="dropdown-item cursor"> 取消 </div>
                                </div>
                            </Dropdown>
                            </td> }
                            
														<td className="text-right">
                            
                            { file.modality==='MR' && file.series==='3D' && file.nii_result !== 'fail' && <span className="d-line-block"><a className="badge badge-warning  mx-1 mb-1"  onClick={()=>this.submitBrainlabel(file.id,file.project_id,'submit_brainlabel')} title=" Create The Brain Segmentation Task"><i className="fa fa-brain"></i> 全脑分割</a></span> }
                            
                            { 
                              file.modality==='PT' && uistyle.is_pet &&
                              <span className="d-line-block mx-1 " onClick={()=>{this.createTask(file,true)}}>
                                <a  className="badge  badge-warning mb-1"   target="_blank"><i className="fa fa-file-medical"></i> 创建PET任务</a>
                              </span>   
                            }
                            
                            <span className="d-line-block mx-1 mb-1">
                              <a className="badge  badge-warning" href={`${dicomviewurl}/#/?keyid=${file.id}&subjectnumber=${subject.subject_name}&age=${parseInt(file.age)}&gender=${subject.subject_gender}&requrl=${config.host}/dicomview/index/`} target="_blank" title="Dicom Image Viewer"><i className="fa fa-file-medical"></i> Dicom阅片</a>
                            </span>
                            
                            </td>
                            <td className="text-right">
                              <Dropdown direction="dropleft">
                                  <div><i className="fa fa-bars"></i> <i className="fa fa-angle-down"></i></div>
                                  <div>
                                      <div className="dropdown-header">操作菜单</div>
                                      { user.level < 2 &&
                                      <div className="dropdown-item cursor" onClick={()=>{ this.download_dicom(file.id)}}><i className="fa fa-download"></i> 下载Dicom文件</div>
                                      }
                                      {
                                          file.nii_result !== 'fail' &&
                                          <a className="dropdown-item cursor" onClick={()=>{ this.download_nii(file.id)}} ><i className="fa fa-download"></i> 下载数据</a>
                                      }
                                      {
                                        file.nii_result === 'fail' && 
                                        <div className="dropdown-item cursor text-danger">转Nifti文件失败</div>
                                      }
                                  </div>
                              </Dropdown>
                          </td>
                          </tr>
                          )
                        })
                      }
                      </tbody>
                      </table>
                      </div>
                  </div>
                )
              })
              }
              </div>
            }

            {
              subject!=='' && subject.archive!=false &&
              <div>
                <div className="text-right text-muted border-bottom p-2 mb-1">其它数据 <small> 共{subject.total_archive}件 </small> </div>

                <div className="p-3">
                {
                  subject.archive.length > 0 && subject.archive.map((file,i)=>{
                  const file_size = this.approx(file.file_size);
                  return(
                      <div className="d-flex justify-content-between border-bottom pb-2" key={i} >
                        <span className="d-line-block">
                          文件名：{file.file_name}
                        </span>
                        <span>{file_size}</span>
                        <span className="cursor d-line-block"> <a href={file.download} target="_blank"><i className="fa fa-download"></i></a> </span>
                      </div>
                    )
                  })
                }
                </div>
              </div>
            }
              
                <div className="px-3 text-right">
                  <Link to={`/console/upload_subject/${subject.project_id}/${subject.attribute_id || 0}/${subjectid}`}  className="btn btn-sm btn-danger mr-3">添加数据</Link>
                  <button type="button" className="btn btn-primary btn-sm" onClick={this.download}><i className="fa fa-download"></i> 批量下载</button>
                </div>
          </div>
        </div>
        <div className="col-3 pt-3">
          {
            subject!=='' &&
                <div className=" animated fadeInDown">
                <h6 className="align-items-center mb-3">
                  受试者详情 <a className="small mx-1 text-primary" onClick={() => { this.modalSubject(subject,'editsubject') }}>[ 编辑 ]</a>
                </h6>
                <ul className="list-group mb-3">

                <li className="list-group-item d-flex justify-content-between lh-condensed">
                      <span>名称</span>
                      <div>{subject.subject_name}</div>
                  </li>
                  { subject.subject_uid ? 
                  <li className="list-group-item d-flex justify-content-between lh-condensed bold">
                    <span>UID</span>
                      <div>{subject.subject_uid}</div>
                  </li>
                  : null }
                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>模态</span>
                    <div>
                    {
                        typeof(subject.modality) !== 'undefined' && subject.modality.length > 0 && subject.modality.map((m, i) => {
                            return m!='archive' && <span className="badge badge-info ml-1" key={i}>{m}</span>
                        })
                    }
                    </div>
                  </li>
                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>年龄</span>
                    <span className="text-muted">{subject.subject_age}</span>
                  </li>

                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>性别</span> <span className="text-muted">{subject.subject_gender==='0' ? '男' : '女'}</span>
                  </li>
									<li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>序列</span>
                     <div>
										{
											typeof(subject.series) !== 'undefined' && subject.series.length>0 && subject.series.map((se,si)=>{
												return (<span key={si} className="badge badge-success ml-1">{se}</span>)
											})
										}
                    </div>
									</li>
                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>标签  <a className="small mx-1 text-info" onClick={() => { this.modalSubject(subject,'tagsubject') }}>[ 设置 ]</a></span>
                     <div className="text-right">
                    {
                      typeof(subject.tags) !== 'undefined' && subject.tags.length>0 && subject.tags.map((se,si)=>{
                        return (<span key={si} className="badge badge-info ml-1 mb-1">{se.name}</span>)
                      })
                    }
                    </div>
                  </li>
                  {subject.subject_explain ? 
                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span>诊断说明</span>
                      <div className="text-muted">{subject.subject_explain || '无'}</div>
                  </li>
                  : null }

                </ul>
                </div>
          }

          {
            subject!=='' && uistyle.is_qcstate && 
                <div className=" mt-3">
                <h6 className="align-items-center mb-3">
                  质量检测 <small>(模态)</small>
                </h6>
                <ul className="list-group mb-3">
                {
                    typeof(subject.subject_modality) !== 'undefined' && subject.subject_modality.length > 0 && subject.subject_modality.map((m, i) => {
                      if(m.modality!='archive'){
                        return (
                          <li className="list-group-item d-flex justify-content-between lh-condensed" key={i} >
                          <span className="badge badge-info ml-1">{m.modality}</span>
                          <div>
                            <Dropdown direction="dropleft">
                                <div> 
                                {!m.qc_state || m.qc_state==0 ? <span>未检测</span> : null} 
                                {m.qc_state==1 ? <span>通过</span> : null} 
                                {m.qc_state==2 ? <span>不通过</span> : null} 
                                <i className="fa fa-bars ml-1"></i> <i className="fa fa-angle-down"></i></div>
                                <div>
                                    <div className="dropdown-header">质量检测</div>
                                    <div className="dropdown-item cursor" onClick={() => { this.qcmodality(m.modality,1) }}><i className="fa fa-calendar-check"></i> 通过 </div>
                                    <div className="dropdown-item cursor" onClick={() => { this.qcmodality(m.modality,2) }}><i className="fa fa-calendar-times"></i> 不通过 </div>
                                    <div className="dropdown-divider"></div>
                                    <div className="dropdown-item cursor"> 取消 </div>
                                </div>
                            </Dropdown>
                          </div>
                          </li>
                          )
                      }
                    })
                }
                </ul>
                </div>
          }

					{
						subject!=='' && subject.task!=='undefined'  && subject.task!==false && subject.task.map((t,i)=>{
							const filesize = this.approx(t.file_size);
							return (
								<ul className="list-group mb-3 " key={i}>
	                <li className="list-group-item d-flex justify-content-between lh-condensed">
	                  <span>文件大小</span>
	                  <span className="text-muted">{filesize}</span>
	                </li>

	                <li className="list-group-item d-flex justify-content-between lh-condensed">
	                  <span>处理状态</span>
	                  <span className="text-muted">{t.status==='1' ? '解析完成' : '正在解析'}</span>
	                </li>

                  <li className="list-group-item d-flex justify-content-between lh-condensed">
                    <span className="text-muted">{  t.file_name.split(',').map((f,n)=>{ return(<i key={n}>{f}<br /></i>) }) } </span>
                  </li>

								</ul>
							)
						})

					}
        </div>

        <Modal title={this.state.modaltitle} display={this.state.modalOpen} close={this.closeModal} submit={this.modalSubmit}>
          {
            this.state.edit_type === 'editsubject' && <Editsubject subject={this.state} handleInputChange={this.handleInputChange.bind(this)} />
          }

          {
            this.state.edit_type === 'tagsubject' && <Tagsubject subject={this.state} handleInputChange={this.handleInputChange.bind(this)} />
          }
        </Modal>


        <Modal title='提醒' display={this.state.ismodal} close={this.closeModal} submit={this.submitModal} text_submit="再次执行">
          <div className="text-center">
          
            <h5>{t1_modal_title}</h5>
            {current_task.status == 2 && <a className="btn btn-dark my-3" href={t1_result_link} target="_blank"><i className="fa fa-brain"></i> 查看结果</a> }
            {current_task.status != 2 && 
            <Link className="btn btn-dark my-3" to={`${t1_result_link}`}><i className="fa fa-brain"></i> 查看结果</Link> }
          </div>
        </Modal>

        <Modal title='提醒' display={this.state.ismodal_download} close={this.closeModal} submit={this.closeModal} hidefooter="true">
          <div className="text-center">
          {
            downloadurl === '' && <span>{download_message}</span>
          }
          {downloadurl!=='' && <a className="btn btn-primary my-3" target="_blank" href={downloadurl}><i className="fa fa-download"></i> {download_message}</a> }
          </div>
        </Modal>

        <Modal title='创建任务' display={this.state.createModal} close={this.closeCreateModal} submit={this.createModalSubmit} modalSize="modal-small" text_submit="提交">
          <div className="form-group row">
              <div className="col-sm-10" style={{'textAlign':'left','cursor' : 'pointer !important','paddingLeft':'30%'}}>

                    <h6 style={{display : this.state.hasSomeFile.PT  ?  'block' : 'none'}}>
                        <input type="radio" name="taskType"  value="PT"    onClick={this.handleChange.bind(this)}  defaultChecked={this.state.taskType == 'PT'} /> AV133 &nbsp;

                        <span className="text-muted"  style={{'fontSize': '12px' ,'color' : '#ccc' , 'display' : this.state.pt_status != false && this.state.pt_status >= 0 ? 'inline-block' : 'none'}} > ({ getStatusText( this.state.pt_status) }) </span>&nbsp;   
                        <a className="text-info"      style={{'fontSize': '12px' ,'color' : '#ccc' , 'display' : this.state.pt_status != false && this.state.pt_status == 2 ? 'inline-block' : 'none'}} onClick={this.viewImg.bind(this,this.state.pt_ok,'pt')}> 查看 </a>
                    </h6>

                    <h6 style={{display : this.state.hasSomeFile.PT &&   this.state.hasSomeFile.CT ?  'block' : 'none'}}>
                        <input type="radio" name="taskType"  value="PTCT"  onClick={this.handleChange.bind(this)}  defaultChecked={this.state.taskType == 'PTCT'} /> PET + CT &nbsp;
                        
                        <span className="text-muted"  style={{'fontSize': '12px' ,'color' : '#ccc' , 'display' : this.state.ptct_status != false && this.state.ptct_status >= 0  ? 'inline-block' : 'none' }} > ({ getStatusText( this.state.ptct_status) }) </span>&nbsp;   
                        <a className="text-info"      style={{'fontSize': '12px' ,'color' : '#ccc' , 'display' : this.state.ptct_status != false && this.state.ptct_status == 2  ? 'inline-block' : 'none' }} onClick={this.viewImg.bind(this,this.state.ptct_ok,'ptct')}> 查看 </a>    
                    </h6>

                    {/*
                      <h6 style={{display : this.state.hasSomeFile.PT &&   this.state.hasSomeFile.MR ?  'block' : 'none'}}>
                          <input type="radio" name="taskType"  value="PTMR" onClick={this.handleChange.bind(this)}  defaultChecked={this.state.taskType == 'PTMR' } /> PET +  MRI &nbsp;
                            
                          <span className="text-muted"  style={{'fontSize': '12px' ,'color' : '#ccc' , 'display' : this.state.ptmr_status != false && this.state.ptmr_status >= 0 ? 'inline-block' : 'none'}} > ({ getStatusText( this.state.ptmr_status) }) </span>&nbsp;   
                          <a className="text-info"      style={{'fontSize': '12px' ,'color' : '#ccc' , 'display' : this.state.ptmr_status != false && this.state.ptmr_status == 2 ? 'inline-block' : 'none'}} onClick={this.viewImg.bind(this,this.state.ptmr_ok,'ptmr')}> 查看 </a>   
                      </h6>
                    */}
              </div>
          </div>
        </Modal>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/apps/console/uncategorized/subject_files.js